import { render, staticRenderFns } from "./changeOrders.vue?vue&type=template&id=0bfde01a&scoped=true&"
import script from "./changeOrders.vue?vue&type=script&lang=js&"
export * from "./changeOrders.vue?vue&type=script&lang=js&"
import style0 from "./changeOrders.vue?vue&type=style&index=0&id=0bfde01a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfde01a",
  null
  
)

export default component.exports